<template>
  <div class="userlist">
    <div class="userlist-search">
      <Form ref="search" :model="search" :label-width="80" class="formsearch">
        <div class="formright">
          <FormItem label="账号" prop="account">
            <Input
              v-model.trim="search.account"
              placeholder="请输入账号名称"
              @on-enter="searchQuota"
              @on-blur="searchQuota"
              style="min-width: 200px"
              clearable
              @on-clear="searchQuota"
            />
          </FormItem>
          <FormItem label="账号主体" prop="body">
            <Input
              v-model.trim="search.bodyAccount"
              placeholder="请输入账号主体"
              @on-enter="searchQuota"
              @on-blur="searchQuota"
              style="min-width: 200px"
              clearable
              @on-clear="searchQuota"
            />
          </FormItem>
          <FormItem label="审核状态" prop="state">
            <Select
              @on-enter="searchQuota"
              @on-change="searchQuota"
              @on-clear="searchQuota"
              v-model="search.state"
              style="min-width: 100px"
              clearable
              placeholder="全部"
            >
              <Option :value="item.id" v-for="item in checkStateList" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="申请时间">
            <DatePicker
              v-model="search.applyTime"
              format="yyyy/MM/dd"
              type="daterange"
              placement="bottom-end"
              placeholder="请选择申请时间"
              transfer
              :editable="false"
              style="width: 220px"
              @on-change="searchQuota"
              clearable
            ></DatePicker>
          </FormItem>
        </div>
      </Form>
    </div>
    <div class="content">
      <Row>
        <Table
          class="tableDom"
          ref="tableRef"
          stripe
          :columns="dataCol"
          :loading="tableLoading"
          :data="dataList"
        >
          <!-- 当前状态0待审核 1已通过 2已驳回 -->
          <template slot-scope="{ row }" slot="checkStatus">
            <div v-if="row.status == 0">
              <span class="dot2"></span>
              待审核
            </div>
            <div v-if="row.status == 1">
              <span class="dot1"></span>
              已通过
            </div>
            <div v-if="row.status == 2">
              <span class="dot3"></span>
              已驳回
            </div>
          </template>
          <!-- 操作 -->
          <template slot-scope="{ row }" slot="actions">
            <span>
              <span
                v-if="row.status == 2"
                class="fontblue mr-16 fontcursor"
                v-permission="['reason']"
                @click="returnReason(row)"
              >驳回原因</span>
            </span>
            <span>
              <span
                class="fontblue mr-16 fontcursor"
                v-permission="['detail']"
                @click="link('/appove/appovedetail', row)"
              >详情</span>
            </span>
          </template>
        </Table>
      </Row>
      <Row class="mt-16 mr-32" type="flex" justify="end">
        <Page
          :total="pageTotal"
          :page-size="pageSize"
          :page-size-opts="psize"
          :current="pageNum"
          @on-change="handlePage"
          @on-page-size-change="sizeChange"
          show-sizer
          show-total
          show-elevator
          placement="top"
          class-name="page"
        />
      </Row>
    </div>
    <!-- 驳回原因 -->
    <turnReason
      v-if="showEdit"
      @close="showEdit = false"
      @confirm="showEdit = false"
      :form="reasonsData"
    />
  </div>
</template>

<script>
import { getQuotaList, getQuotaDetail } from "@/api/appove";
import turnReason from "./components/TurnReason";
import TableMixin from "@/utils/mixins/tableMixin";
const dataCol = [
  {
    title: "账号",
    key: "loginAccount",
    tooltip: true,
    minWidth: 130
  },
  {
    title: "申请原因",
    key: "cause",
    tooltip: true,
    minWidth: 130
  },
  {
    title: "配额数量",
    key: "applyLimit",
    tooltip: true,
    minWidth: 130
  },
  {
    title: "账号主体",
    key: "companyName",
    tooltip: true,
    minWidth: 130
  },
  {
    title: "申请时间",
    key: "createTime",
    tooltip: true,
    minWidth: 150
  },
  {
    title: "审核状态",
    slot: "checkStatus",
    tooltip: true,
    minWidth: 100
  },
  {
    title: "操作",
    slot: "actions",
    minWidth: 160
  }
];
export default {
  components: {
    turnReason
  },
  mixins: [mixins, TableMixin],
  data() {
    return {
      Recovery: {
        path: ["/appove/appovedetail"],
        key: ["search", "pageSize", "pageNum"]
      },
      tableLoading: false,
      pageTotal: 0,
      pageSize: 10,
      pageNum: 1,
      psize: [10, 20, 50, 100],
      dataList: [],
      dataCol: dataCol,
      search: {
        account: "",
        bodyAccount: "",
        state: "",
        applyTime: []
      },
      showDialog: false,
      dataForm: {},
      showEdit: false, //修改应用
      K: "",
      // 审核状态
      checkStateList: [
        {
          id: 0,
          name: "待审核"
        },
        {
          id: 1,
          name: "已通过"
        },
        {
          id: 2,
          name: "已驳回"
        }
      ],
      companyLimit: {},
      reasonsData: {}
    };
  },
  created() {
    this.search.applyTime.length > 0 &&
      (this.search.applyTime = [
        this.$moment(this.search.applyTime[0]).format("YYYY-MM-DD HH:mm"),
        this.$moment(this.search.applyTime[1]).format("YYYY-MM-DD HH:mm")
      ]);
    let self = this;
    this.getList(); //获取服务提供者审核列表
  },
  mounted() {},
  computed: {},
  methods: {
    // 获取配额审批列表
    getList() {
      let self = this;
      let query = {
        loginAccount: this.search.account,
        companyName: this.search.bodyAccount,
        status: this.search.state,
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.search.applyTime.length && this.search.applyTime[0] != "") {
        query.createTimeBegin = this.$moment(this.search.applyTime[0]).format(
          "YYYY-MM-DD"
        );
        query.createTimeEnd =
          this.$moment(this.search.applyTime[1]).format("YYYY-MM-DD") +
          " 23:59:59";
      } else {
        delete this.search.createTimeBegin;
        delete this.search.createTimeEnd;
      }
      console.log("获取配额列表query", query);
      console.log("this.search", this.search);
      getQuotaList(query).then(res => {
        let json = res.data.data;
        json.forEach(item => {
          item.loginAccount = item.loginAccount || "-";
        });
        this.pageTotal = res.data.page.totalCount;
        this.dataList = json;
      });
    },
    // 分页==页码修改(ok)
    handlePage(value) {
      let self = this;
      self.pageNum = value;
      self.getList();
    },
    // 分页==每页显示数量修改(ok)
    sizeChange(value) {
      let self = this;
      self.pageSize = value;
      self.$nextTick(() => {
        self.getList();
      });
    },
    // 查询服务
    searchQuota() {
      this.pageNum = 1;
      // this.pageSize = 10;
      this.getList();
    },
    // 查看驳回原因
    returnReason(row) {
      getQuotaDetail(row.id)
        .then(res => {
          this.companyLimit = res.data.data.companyLimit;
          console.log("=========", res);
          this.reasonsData = {
            rejectCause: this.companyLimit.rejectCause,
            auditor: this.companyLimit.approver,
            auditTime: this.companyLimit.auditTime
          };
        })
        .catch(err => {
          console.log("err", err);
        });

      console.log("点击了驳回原因");
      this.showEdit = true;
    },
    link(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: {
            id: item.id
          }
        });
      } else {
        this.$router.push({ path: path });
      }
    }
  }
};
</script>

<style lang="scss">
.userlist {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 24px 32px;
  overflow-y: auto;
  &-search {
    display: flex;
    width: 100%;
    .formsearch {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: flex-end;
      > .formright {
        width: calc(100% - 94px);
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
      }
    }
  }
  .tableDom {
    width: 100%;
    .logo {
      width: 36px;
      height: 36px;
    }
    .dot1,
    .dot2,
    .dot3 {
      display: inline-block;
      width: 6px;
      height: 6px;
      background: #67c23a;
      border-radius: 50%;
    }
    .dot2 {
      background: #0099ff;
    }
    .dot3 {
      background: #ff0000;
    }
  }
}
</style>
